export enum PromotionCodeState {
  None = 0,
  Ok = 1,
  Expired = 2,
  NotValid = 3,
  Error = 4,
  NotMultiple = 5
}
